/**
 * StudentProfilePrompt — la relance annuelle « Personnalise ton profil » dans le nouvel espace, à la
 * place de `student/account/ProfileCustomizationPromptModal.js`.
 *
 * Montée par la branche du design system de `common/main-menu/BottomTabsNavigator.js`, à côté de
 * `StudentNavigator` : le déclencheur reste celui de la coquille, partagé avec l'ancien espace. Les
 * gestes : `useStudentProfilePromptState`.
 */
import React from "react"

import { StudentProfilePromptModal } from "../../../../../../design-system/student"
import { useStudentProfilePromptState } from "./useStudentProfilePromptState"

export type StudentProfilePromptProps = {
    visible: boolean
    onDismiss: () => void
}

export function StudentProfilePrompt({ visible, onDismiss }: StudentProfilePromptProps) {
    const prompt = useStudentProfilePromptState(onDismiss)

    return <StudentProfilePromptModal visible={visible} {...prompt} />
}
